module.exports = __webpack_public_path__ + "d9a7751a46853dae68c8f5426dfb8465.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/trash.png
// module id = 228
// module chunks = 0